import Axios from "axios";
import Auth from "./auth";

export default {
  async getJSON(method, url, body = null) {
    const res = await Axios({
      method: method,
      url: "api/" + url,
      data: body,
      headers: {
        Authorization: "sesid " + Auth.getSesId()
      }
    });
    let data = res.data && res.data.data;
    return data;
  },
  async getBlob(method, url, body = null) {
    const res = await Axios({
      method: method,
      url: "api/" + url,
      data: body,
      headers: {
        Authorization: "sesid " + Auth.getSesId()
      },
      responseType: "arraybuffer"
    });
    return res;
  },
  getFirstError(error) {
    if (error && error.response) {
      if (error.response.data) {
        let data = error.response.data;
        if (data instanceof ArrayBuffer) {
          data = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(data))
          );
        }
        if (data.errors && data.errors[0]) {
          return data.errors[0].detail || data.errors[0].title;
        }
      }
      return error.response.statusText;
    }
    return error.toString();
  }
};
